<template>
  <b-field label="Regione">
    <b-select placeholder="Seleziona regione" v-model="object.regionId" expanded required>
      <option
        v-for="option in $ajax.getObject('regions')"
        :value="option.id"
        :key="option.id"
      >{{ option.name }}</option>
    </b-select>
  </b-field>
</template>

<script>
export default {
  props: ["object"]
};
</script>
